import { useEffect, useState } from 'react';
import { getLocale } from '../../contexts/LanguageContext';

export const fmtKamas = (n) => `${Math.round(n || 0).toLocaleString(getLocale()).replace(/ /g, ' ')} k`;
export const fmtKamasLong = (n) => `${Math.round(n || 0).toLocaleString(getLocale()).replace(/ /g, ' ')} kamas`;
export const fmtDateTime = (d) => (d ? new Date(d).toLocaleString(getLocale(), { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }) : '—');

/** Temps restant lisible : « 1 j 4 h », « 2 h 05 », « 4:32 », « Terminé ». */
const REMAINING_WORDS = {
    fr: { ended: 'Terminé', day: 'j' },
    en: { ended: 'Ended', day: 'd' },
    es: { ended: 'Terminado', day: 'd' }
};

export const fmtRemaining = (ms) => {
    const words = REMAINING_WORDS[getLocale().slice(0, 2)] || REMAINING_WORDS.fr;
    if (ms <= 0) return words.ended;
    const s = Math.floor(ms / 1000);
    const d = Math.floor(s / 86400);
    const h = Math.floor((s % 86400) / 3600);
    const m = Math.floor((s % 3600) / 60);
    const sec = s % 60;
    if (d > 0) return `${d} ${words.day} ${h} h`;
    if (h > 0) return `${h} h ${String(m).padStart(2, '0')}`;
    return `${m}:${String(sec).padStart(2, '0')}`;
};

/**
 * Horloge alignée sur celle du serveur (décalage calculé à partir de `serverNow`),
 * rafraîchie chaque seconde pour les comptes à rebours.
 */
export const useServerClock = (serverNow) => {
    const [offset, setOffset] = useState(0);
    const [now, setNow] = useState(Date.now());

    useEffect(() => {
        if (serverNow) setOffset(new Date(serverNow).getTime() - Date.now());
    }, [serverNow]);

    useEffect(() => {
        const id = setInterval(() => setNow(Date.now()), 1000);
        return () => clearInterval(id);
    }, []);

    return now + offset;
};

/** Format d'un champ datetime-local (heure locale) pour une date. */
export const toLocalInput = (date) => {
    const d = new Date(date);
    const pad = (n) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};
